// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../../node_modules/@angular-devkit/build-angular/node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/@angular-devkit/build-angular/node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.variableStack {
    max-height: 200px;
}

.variableElem > * {
    align-self: center;
    margin: 0px 4px;
}

.variableValueElem {
    width: 200px;
}`, "",{"version":3,"sources":["webpack://./src/app/settings/connector/connector.overview.settings.css"],"names":[],"mappings":"AAAA;IACI,iBAAiB;AACrB;;AAEA;IACI,kBAAkB;IAClB,eAAe;AACnB;;AAEA;IACI,YAAY;AAChB","sourcesContent":[".variableStack {\n    max-height: 200px;\n}\n\n.variableElem > * {\n    align-self: center;\n    margin: 0px 4px;\n}\n\n.variableValueElem {\n    width: 200px;\n}"],"sourceRoot":""}]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___.toString();
